import { Field, Form, Formik } from "formik";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import Notification from "pages/_components/Notification";
import TextField from "pages/_components/fields/TextField";
import { bool } from "prop-types";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import ResponsiveHeader, { DesktopButtons, MobileButtons } from "pages/_components/header";
import useSchema from "hooks/useSchema";
import * as Yup from "yup";
import { actions as comexActions } from "reducers/comex";
import Image from "pages/_components/Image";
import I18n from "pages/_components/I18n";
import { push } from "connected-react-router";
import Action from "pages/_components/Action";
import ComexStepper from "../_components/ComexStepper";

const FORM_ID = "comex.payment.service";

const StepServicePayment = ({ isDesktop }) => {
    const dispatch = useDispatch();

    const { comexTransfer = {}, comexId = null } = useSelector((state) => state.comex);
    const { paymentService = {} } = comexTransfer;
    const { stringRequired } = useSchema();
    const [isSaved, setIsSaved] = useState(false);

    const initialValues = {
        description: paymentService?.description || "",
        condition: paymentService?.condition || "",
        frequency: paymentService?.frequency || "",
    };

    const validationSchema = Yup.object().shape({
        description: stringRequired,
        condition: stringRequired,
    });

    const saveComexRequest = (isContinue) => {
        const _comexTransferRequest = {
            ...comexTransfer,
            step: "stepSERVICEPAYMENT",
            comexId,
            isContinue,
        };
        dispatch(comexActions.createComexTransfer(_comexTransferRequest));
        setIsSaved(true);
    };

    const handleSubmit = () => {
        saveComexRequest(true);
        dispatch(push("/comex/ddjj/service"));
    };

    const [formData, setFormData] = useState({});

    useEffect(() => {
        dispatch(
            comexActions.setComexTransfer({
                ...comexTransfer,
                paymentService: {
                    ...formData,
                },
            }),
        );
        setIsSaved(false);
    }, [formData]);

    return (
        <>
            {isDesktop && <ComexStepper isDesktop={isDesktop} currentStep={7} />}
            <Notification scopeToShow="ComexNotification" />
            <ResponsiveHeader ticket metaTitle="comex.payment.service.title" backLinkTo="/comex/service/documentation">
                <DesktopButtons>
                    <Button
                        className="btn btn-outline btn-block small"
                        onClick={() => {
                            saveComexRequest();
                        }}
                        disabled={isSaved}>
                        <Image
                            src={isSaved ? "images/figma/icon/check.svg" : "images/figma/icon/save.svg"}
                            className="icon-medium svg-icon"
                        />
                        <I18n id={isSaved ? "comex.transfer.save.ok.btn" : "comex.transfer.save.btn"} />
                    </Button>
                </DesktopButtons>
                <MobileButtons>
                    <Action
                        labelKey="comex.transfer.save.btn"
                        handleClick={() => saveComexRequest()}
                        disabled={isSaved}
                    />
                </MobileButtons>
            </ResponsiveHeader>

            <MainContainer>
                <Notification scopeToShow="mepNotification" />
                <I18n component="h2" id="comex.payment.service.title" />
                <I18n component="h3" id="comex.payment.service.details" />

                <Formik
                    initialValues={initialValues}
                    onSubmit={() => handleSubmit()}
                    validationSchema={validationSchema}>
                    {({ values }) => {
                        const canSubmit = !values.description || !values.condition;

                        setFormData(values);
                        return (
                            <Form>
                                <GridTable className="form transfer-others">
                                    <GridTable.Container columns={12} columnsTemplate="fixed">
                                        <GridTable.Data className="required" columnStart={2} columnWidth={5}>
                                            <Field
                                                component={TextField}
                                                idForm={FORM_ID}
                                                name="description"
                                                hidePlaceholder
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data className="required" columnStart={7} columnWidth={5}>
                                            <Field
                                                component={TextField}
                                                idForm={FORM_ID}
                                                name="condition"
                                                hidePlaceholder
                                            />
                                        </GridTable.Data>
                                        <GridTable.Data columnStart={2} columnWidth={5}>
                                            <Field
                                                component={TextField}
                                                idForm={FORM_ID}
                                                name="frequency"
                                                hidePlaceholder
                                                maxLength={20}
                                            />
                                        </GridTable.Data>
                                    </GridTable.Container>
                                </GridTable>
                                <Row className="form-actions">
                                    <Col xs={12} md={4} mdOffset={4}>
                                        <Button
                                            type="submit"
                                            className="btn-primary"
                                            label="global.continue"
                                            disabled={canSubmit}
                                        />
                                    </Col>
                                </Row>
                            </Form>
                        );
                    }}
                </Formik>
            </MainContainer>
        </>
    );
};

StepServicePayment.propTypes = {
    isDesktop: bool.isRequired,
};

export default StepServicePayment;
